/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Hero_BodyInputs */

const en_road_dude_hero_body = /** @type {(inputs: Road_Dude_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Put your dog, your cat, or yourself behind the wheel. Watch how creators remake the fishing-pond encounter, then pick a prompt for your own AI video.`)
};

const zh_road_dude_hero_body = /** @type {(inputs: Road_Dude_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让狗狗、猫咪或你自己坐进皮卡驾驶位。看看创作者如何翻拍池塘边的经典一幕，再选一条提示词制作你的 AI 视频。`)
};

/**
* | output |
* | --- |
* | "Put your dog, your cat, or yourself behind the wheel. Watch how creators remake the fishing-pond encounter, then pick a prompt for your own AI video." |
*
* @param {Road_Dude_Hero_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_hero_body = /** @type {((inputs?: Road_Dude_Hero_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Hero_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_hero_body(inputs)
	return zh_road_dude_hero_body(inputs)
});
export { road_dude_hero_body as "road_dude.hero.body" }